import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { BasicSearchRequest } from '../../../Models/BasicSearchRequest';
import { formatDateInputs } from '../../../Utils';
import ReportsApi from '../../../Api/ReportsApi';
import ViewReportModal from '../../Common/ViewReportModal';

export default function PayrollModal({
  show,
  setShow,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pdfBlob, setpdfBlob] = useState<Blob | null>(null);
  const [pdfURL, setPDFURL] = useState<string>('');
  const [fileName, setfileName] = useState<string>('');
  const [showdropTicketModal, setshowdropTicketModal] =
    useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<BasicSearchRequest>({
    status: 0,
    fromDate: '',
    toDate: '',
  });
  const handleResetFormValues = () => {
    const values = {
      status: 0,
      fromDate: '',
      toDate: '',
    };
    setFormData(values as BasicSearchRequest);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setButtonDisabled(true);
    return await ReportsApi.getPayrollReport(formData)
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        setpdfBlob(pdfBlob);
        setPDFURL(url);
        const fromDay = new Date(formData.fromDate).getDate() + 1;
        const fromMonth = new Date(formData.fromDate).getMonth() + 1;
        const toDay = new Date(formData.toDate).getDate() + 1;
        const toMonth = new Date(formData.toDate).getMonth() + 1;

        setfileName(
          `payroll_${fromMonth + '-' + fromDay}_${toMonth + '-' + toDay}`
        );
        setshowdropTicketModal(true);
        setIsLoading(false);
        setButtonDisabled(false);
        // onCloseModal();
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    setButtonDisabled(false);
    handleResetFormValues();
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full mb-4'>
              <div className='mx-1 flex items-end justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>Payroll</h1>
              </div>
            </div>
            <form onSubmit={onSubmit}>
              <div className='text-gray-500'>
                <div className='grid grid-cols-[20%_80%] text-xl'>
                  <div className='flex'>
                    <div className='font-bold content-center'>Dates:</div>
                  </div>
                  <div className='w-full flex gap-2'>
                    <div className='flex gap-1 w-1/2'>
                      <div className='content-center text-xl font-bold'>
                        From:
                      </div>
                      <div className='w-full'>
                        <TextInput
                          id='fromDate'
                          name='fromDate'
                          type='date'
                          onChange={handleChange}
                          value={formatDateInputs(formData.fromDate ?? '')}
                          sizing='md'
                          pattern='\d{4}-\d{2}-\d{2}'
                          required
                        />
                      </div>
                    </div>
                    <div className='flex gap-1 w-1/2'>
                      <div className='content-center text-xl font-bold'>
                        To:
                      </div>
                      <div className='w-full'>
                        <TextInput
                          id='toDate'
                          name='toDate'
                          type='date'
                          onChange={handleChange}
                          value={formatDateInputs(formData.toDate ?? '')}
                          sizing='md'
                          pattern='\d{4}-\d{2}-\d{2}'
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex justify-end pt-4'>
                <Button
                  type='submit'
                  className='buttonMain'
                  disabled={buttonDisabled}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <ViewReportModal
        show={showdropTicketModal}
        setShow={setshowdropTicketModal}
        url={pdfURL}
        fileName={fileName}
        blob={pdfBlob}
      />
    </>
  );
}
